import { DEFAULT_LIST_WIDTH } from '../../../../model/table';

const MAX_WIDTH_RATIO = 0.9;

/* The list section of the table can be resized.
 * It should not become larger than the overall size of the table,
 * but it should also not become smaller than its default size.
 */
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (tableWidth: number) => {
	const tableLimitedWidth = Math.round(tableWidth * MAX_WIDTH_RATIO);
	return Math.max(DEFAULT_LIST_WIDTH, tableLimitedWidth);
};
